// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDk8qSGT3CEqLbGyLiCnnrW3pWdfDOztBQ",
  authDomain: "netflixgpt-210c2.firebaseapp.com",
  projectId: "netflixgpt-210c2",
  storageBucket: "netflixgpt-210c2.firebasestorage.app",
  messagingSenderId: "1024957774943",
  appId: "1:1024957774943:web:141cfaf710427683806fea",
  measurementId: "G-BGJVLF78WH",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app); // Initialize analytics

export const auth = getAuth(app);
